import { getCurrentInstance, ref } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import Toast from 'vant/lib/toast';
import { sendLog } from '~/common/radar';
import { Picture } from '~/api/topic';
import { PwaBridge } from '~/common/bridge';

type PictureActionItemProps = {
    index?: number;
    picture?: Picture;
    isLoginStatus?: boolean;
};

export const PictureActionItemAppSetup = (props: PictureActionItemProps) => {
    const { proxy } = getCurrentInstance() || {};
    const isLiked = ref(false);

    const sendCardLog = (buttonType: string) => {
        sendLog({
            type: 'click',
            name: 'PHOTO_CARD_SPECIAL',
            value: {
                button_type: buttonType,
                card_type: 'photo_text',
                card_position: props.index,
            },
        });
    };

    const excuteLikeAction = debounce(async () => {
        sendCardLog('like');

        isLiked.value = !isLiked.value;
    }, 300);

    const excuteCommentAction = debounce(async () => {
        sendCardLog('comment');

        Toast({
            message: proxy?.$root.$t('pictuer_click_comment_toast'),
        });
    }, 300);

    const excuteDownloadAction = debounce(async () => {
        sendCardLog('download');

        const pictureUrl = props.picture?.pic_origin_url || '';
        if (!pictureUrl) return;

        try {
            const res = await PwaBridge.saveMediaToAlbum({
                url: pictureUrl,
                mediaType: 'image',
            });
            // eslint-disable-next-line no-console
            console.log('res', res);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, 300);

    return {
        isLiked,
        excuteLikeAction,
        excuteCommentAction,
        excuteDownloadAction,
    };
};
